export default {
  httpStatus: {code: 200, message: 'OK', __typename: 'HttpStatus'}
}
